// extracted by mini-css-extract-plugin
module.exports = {"productSlider":"product-slider_productSlider__ODLDT","isStartPage":"product-slider_isStartPage__dHRpb","swiperWrapperMobile":"product-slider_swiperWrapperMobile__wyKyl"};